import List, { SkeletonListItems } from '@/components/List';
import ProjectsListItem, {
  type ProjectsListItemProps,
} from './ProjectsListItem';

export { ProjectsListItem, type ProjectsListItemProps };

export type ProjectsListProps = {
  isFetchingData?: boolean;
  showUser?: boolean;
  className?: string;
  projectIds?: number[];
  variant?: ProjectsListItemProps['variant'];
  onSelect?: (projectId: number) => void;
};

export default function ProjectsList({
  isFetchingData,
  showUser,
  className,
  projectIds = [],
  variant,
  onSelect,
}: ProjectsListProps) {
  return (
    <List className={className}>
      {isFetchingData ? (
        <SkeletonListItems />
      ) : (
        projectIds.map((id) => (
          <ProjectsListItem
            key={id}
            showUser={showUser}
            projectId={id}
            variant={variant}
            onSelect={onSelect ? () => onSelect(id) : undefined}
          />
        ))
      )}
    </List>
  );
}
